var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero',{attrs:{"img":"https://image.freepik.com/photos-gratuite/femme-vetements-verts_144627-35678.jpg","text":"EXPERTISE EN CONFORT THERMIQUE ET DOMOTIQUE","subText":_vm.presentation,"buttonTitle":""}}),_c('contact-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }